import { makeStyles } from '@fluentui/react-components';
import DataGridContent from './datagrid-content';
import AutomationRuleActivityProvider from './activity-provider';
import ActivityFilterControl from './filter';

export default function AutomationRuleAllActivity() {
	const classes = useStyles();
	
	return (
		<AutomationRuleActivityProvider>
			<div className={classes.root}>
				<ActivityFilterControl />
				<div className={classes.datagridRoot}>
					<DataGridContent />
				</div>
			</div>
		</AutomationRuleActivityProvider>
	);
}

export const useStyles = makeStyles({
	root: {
		padding: '16px 0',
		boxSizing: 'border-box'
	},
	datagridRoot: {
		height: '100%',
		width: '100%',
		position: 'relative',
	},
});